import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';

// A short teaser band linking to the new /our-team page, placed directly
// after PricingSection on the homepage per explicit user request ("Add it
// as a separate page linked on the homepage after Pricing").
export default function TeamTeaserSection({ isDarkTheme }) {
  const navigate = useNavigate();
  const textColor = isDarkTheme ? 'text-white' : 'text-navy';
  const textMuted = isDarkTheme ? 'text-white/70' : 'text-text-slate';
  const cardBg = isDarkTheme ? 'bg-white/5 border-white/10' : 'bg-surface-light border-gray-200';

  return (
    <section className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className={`rounded-card border ${cardBg} p-8 sm:p-10 flex flex-col sm:flex-row items-center gap-6 sm:gap-8`}>
        <div className="p-4 rounded-btn bg-brand-gradient flex-shrink-0">
          <Users className="text-white" size={28} />
        </div>
        <div className="flex-1 text-center sm:text-left">
          <h3 className={`text-xl sm:text-2xl font-display font-bold ${textColor} mb-1`}>Meet the People Behind RUDVAN</h3>
          <p className={`text-sm sm:text-base ${textMuted}`}>Get to know the founders and leadership shaping RUDVAN's vision.</p>
        </div>
        <button
          onClick={() => navigate('/our-team')}
          className="w-full sm:w-auto flex-shrink-0 flex items-center justify-center gap-2 px-6 py-3 rounded-btn bg-brand-blue hover:bg-brand-blue-hover text-white text-sm font-semibold transition-all duration-300 shadow-brand-btn"
        >
          Our Team
          <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
}
